import React, { lazy, useEffect, useState } from "react";
import { navigate } from "@reach/router"
import loadable from "@loadable/component"
import JsPDF from "jspdf";

import "./FormPage.scss";

import TextImageBlock from "../TextImageBlock/TextImageBlock";

import Book_A_Valuation from "../forms/book_a_valuation";
import Book_A_Viewing from "../forms/book-a-viewing";
import Branch_Contact from "../forms/branch-contact-form";
import Staff_Contact from "../forms/member-form";
import Contact_Form from "../forms/contact-form";
import Ask_Question_Form from "../forms/ask-question-form";
import SendToFriend_Form from "../forms/send-property-to-friend";
import Instant_valuation_Form from "../forms/instant-valuation-form";
import CollectionForm from "../forms/collection-form";

import Complaints_Form from "../forms/complaints-form";
import Bulk_Enquiry_Form from "../forms/bulk-enquiry-form";
import Referral_Form from "../forms/referral_form";
import Requirements_Form from "../forms/requirements_form";
import Discounts_Form from "../forms/bv_discounts";
import Rent_Student_Home from "../forms/rent_student_home";
import Tenant_Offer from "../forms/tenancy-offer";
import Register_Interest from "../forms/register-interest-form";
import Contact_Investment from "../forms/contact-investment-centre";
import Valuation from "../ValuationReport/ValuationReport";
import ValuationForm from "../ValuationPage/ValuationForm";
import LuckyWinnerForm from "../forms/lucky-winners";

//import PaymentForm from "../forms/payment";
//import Rent_Home from "../forms/rent_a_home";

import ContentModule from "../../modules/content_module";
import { capitalize } from "lodash";

import {leadooPageSlot, defaultArea_Slug} from "../../common/constant";
import {PageLinks} from "../../common/page-links";

import {RenderComponent} from "../../modules/render-component";

//const JsPDF = loadable(() => import("jspdf"));
const PaymentForm = loadable(() => import("../forms/payment"))
const Rent_Home = loadable(() => import("../forms/rent_a_home"))

const FormsWrapper = ({ form_data, form_type, location, to_email_id, branch_name, staff_name, menu_slug, description, title, GQLModules, banner_image, to_let_email_id }) => {

    const renderComponent = RenderComponent()

    const[blob_obj, setBlobObj] = useState("");

    const [result, setResult] = useState(null);
    const [thankyou, setThanksyou] = useState(false);

    let prev_state = location?.state;

    //console.log("form_type ==>", form_type);

    let pathname = menu_slug ? menu_slug.replace(/-/g, '_') : "";
    

    useEffect(() => {
        if(form_type === "book_a_viewing" && prev_state === null){
            navigate(`/${PageLinks.property_for_sale}/in-${defaultArea_Slug}/`)
        }
        // if(form_type === "investment_centre" && prev_state === null){
        //     navigate(`/${PageLinks.investment_centre}/`)
        // }
    }, [form_type])

    const htmlStringToPdf = async (html_string) => {
        //let htmlString = "<p><b>This text is bold</b></p><p><i>This text is italic</i></p><p>This is<sub> subscript</sub> and <sup>superscript</sup></p>";
        let htmlString = html_string;

        //console.log("htmlString", htmlString)

        let div = document.createElement("div");
        //div.style.visibility = "hidden";
        div.id="pdf_file"
        document.body.appendChild(div);
        div.innerHTML = htmlString;
        
        //let canvas = await html2canvas(div, {});
        
        // Convert the iframe into a PNG image using canvas.
        //let imgData = canvas.toDataURL("image/png", 1.0);

        let jsPdf = new JsPDF('p', 'pt', 'letter');
        var htmlElement = document.getElementById('pdf_file');

        const opt = {
            callback: function (jsPdf) {
                //jsPdf.save("Test.pdf");
                // to open the generated PDF in browser window
                //window.open(jsPdf.output('bloburl'));
                console.log("bloburl", jsPdf.output('bloburl'), jsPdf.output("blob"))

                // //let blobPDF = new Blob([ jsPdf.output("blob") ], { type: 'application/pdf'});
                setBlobObj(jsPdf.output("blob"));
                document.getElementById("pdf_file").remove();
            },
            margin: [30, 30, 30, 30],
            autoPaging: 'text',
            html2canvas: {
                allowTaint: true,
                dpi: 300,
                letterRendering: false,
                logging: false,
                scale: .65
            }
        };

        let blobPdf = {};
        jsPdf.html(htmlElement, opt)


        //console.log("bloburl", jsPdf.output('bloburl'), jsPdf.output("blob"))

        //console.log("blob_object", blob_obj);
    };


    return (
        <React.Fragment>
            <div className={`form-wrapper ${form_type === "payment" ? "payment_form" : ""}`}>

            {result ?
                <Valuation {...result} setResult={setResult} setThanks={()=>{
                    setThanksyou(true)
                }} banner_image={banner_image}/>
            :
                <>

                    <h1 className="form_heading">{form_data?.title ? form_data?.title : "Contact Us"}</h1>

                    {
                        (prev_state?.form_type === "book_a_viewing" || prev_state?.form_type === "send_to_friend") ?
                        <p><span>{capitalize(prev_state?.property_data?.title)}</span><br />{prev_state?.property_data?.display_address}</p>
                        :
                        <p>{form_data?.content ? form_data?.content : ""}</p>
                   }
                    
                    {description && <ContentModule Content={description} />}

                    {prev_state?.form_type === "book_a_viewing" ?
                        <Book_A_Viewing propertyData={prev_state?.property_data} property_url={prev_state?.property_url} to_email_id={prev_state?.to_email_id} banner_image={banner_image} />
                    : form_type === "investment_centre" ?
                        <Contact_Investment propertyData={prev_state?.property_data} property_url={prev_state?.property_url} to_email_id={prev_state?.to_email_id} />
                    : form_type === "book_a_valuation" ?
                        <Book_A_Valuation banner_image={banner_image} />
                    : form_type === "branch_contact" ?
                        <Branch_Contact to_email_id={to_email_id} to_let_email_id={to_let_email_id} formLabel={branch_name} branch_name={branch_name} />

                    : form_type === "instant_valuation" ?
                        <Instant_valuation_Form to_email_id={to_email_id} formLabel={branch_name} branch_name={branch_name} setResult={setResult} banner_image={banner_image} />

                    : form_type === "staff_contact" ?
                        <Staff_Contact to_email_id={to_email_id} formLabel={staff_name} staff_name={staff_name} />
                    : (form_type === "send_to_friend") ?
                        <SendToFriend_Form propertyData={prev_state?.property_data} property_url={prev_state?.property_url} />
                    : form_type === "ask_a_question" ?
                        <Ask_Question_Form to_email_id={to_email_id}/>
                    : form_type === "payment" ?
                        <PaymentForm  to_email_id={to_email_id}/>
                    : form_type === "join_collection" ?
                        <CollectionForm  to_email_id={to_email_id}/>
                    : form_type === "complaints" ?
                        <Complaints_Form  to_email_id={to_email_id}/>
                    : form_type === "rent_a_home" ?
                        <Rent_Home to_email_id={to_email_id} htmlStringToPdf={htmlStringToPdf} blob_obj={blob_obj} setBlobObj={setBlobObj}/>
                    : form_type === "bulk_enquiry" ?
                        <Bulk_Enquiry_Form to_email_id={to_email_id} prev_state={prev_state}/>
                    : form_type === "referral_forms" ?
                        <Referral_Form to_email_id={to_email_id}  title={title} />
                    : form_type === "requirements_form" ?
                        <Requirements_Form to_email_id={to_email_id}  title={title} />
                    : form_type === "discounts_form" ?
                        <Discounts_Form to_email_id={to_email_id}  title={title} />
                    : form_type === "student_home" ?
                        <Rent_Student_Home to_email_id={to_email_id}  title={title}  />
                    : form_type === "offer_form" ?
                        <Tenant_Offer to_email_id={to_email_id}  title={title}  />
                    : form_type === "register_interest" ?
                        <Register_Interest to_email_id={to_email_id}  title={title}  />
                    : form_type === "valuation" ?
                        <ValuationForm to_email_id={to_email_id}  title={title} formLabel={branch_name} branch_name={branch_name} setResult={setResult} banner_image={banner_image}  />
                    : form_type === "lucky_winners" ?
                        <LuckyWinnerForm to_email_id={to_email_id}  title={title}  />
                    : form_type === "none" ?
                        ""
                    :
                        // <Contact_Form  to_email_id={to_email_id} title={title} htmlStringToPdf={htmlStringToPdf} />
                        <Contact_Form  to_email_id={to_email_id} title={title} menu_slug={menu_slug} banner_image={banner_image} />
                    }

                    {GQLModules?.length > 0 && GQLModules?.map((Module, index) => {
                        return(<>
                            {Module.__typename === "GLSTRAPI_ComponentComponentsTextBlockWithImage" &&  <TextImageBlock key={Module} Module={Module}/>}
                        </>
                        )
                    })
                    }

                    {/* <button onClick={htmlStringToPdf}>Generate</button> */}
                </>
            }
            </div>
            {/* {leadooPageSlot?.sell_property &&
                <ld-slot name={leadooPageSlot[pathname]}></ld-slot>
            } */}
        </React.Fragment>
    );
};
export default FormsWrapper;